import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $name: String!, $costModifier: Float!, $postClickLookback: Int!, $postViewLookback: Int!) {
    createAdvertiser (input: {
        id: $id
        name: $name
        costModifier: $costModifier
        postClickLookback: $postClickLookback
        postViewLookback: $postViewLookback
    }) {
        __typename
        id
        name
        costModifier
        postClickLookback
        postViewLookback
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Roles/NewMutation.js